export const DELETE_CHARACTERSTIC_MUTATION = `mutation DeleteCharacteristic($charactersticId: ID!) { 
deleteCharacterstic(charactersticId: $charactersticId) 
}

`